import { render, staticRenderFns } from "./ProfileByPublicKey.vue?vue&type=template&id=4d2e5b16&scoped=true&"
import script from "./ProfileByPublicKey.vue?vue&type=script&lang=js&"
export * from "./ProfileByPublicKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2e5b16",
  null
  
)

export default component.exports